// import { thumbnailSizeMap } from '../../Data/consts'
import { CLI_V2, LANG_V2, PRE_BLOCK, PRE_IMG, REP_BLOCK, REP_IMG, REP_SEC, REP_V2, SUB, TOP_BLOCK, USR, PROP } from '../../Data/typeDirs'
// import { filesGetThumbnailBatch } from '../../Services/dropbox'
import { DateToFormattedString, genId } from '../../utils'
import { createReportSchema } from './defaults/createReportSchema'
// import { Subcategory } from '../languageObjects'
import { preambleBlockSchema } from './defaults/preambleBlockSchema'
import { exportSchema } from './defaults/reportExportSchema'
import { topBlockSchema } from './defaults/topBlockSchema'
import { PreambleImage } from './preambleImage'
import { ReportBlock } from './reportBlock'
import { PreambleBlock } from './preambleBlock'
import { ReportImage } from './reportImage'
import { TopBlock } from './topBlock'
import { mapChildArrayToObjects } from './utils'
import { reportBlockSchema } from './defaults/reportBlockSchema'
import { frontMatterSchema } from './defaults/frontMatterSchema'
import { exportTableOfContentsSchema } from './defaults/exportTableOfContentsSchema'
import { exportPreambleBlockSchema } from './defaults/exportPreambleBlockSchema'
import { exportTopBlockSchema } from './defaults/exportTopBlockSchema'


class ReportV2 {
  constructor(data = {}) {
    this._id = data._id || genId()
    this.name = data.name || 'New Report'
    const client = data.clients_v2 && typeof data.clients_v2 === 'string' ? {_id:data.clients_v2} : data.clients_v2 || {}
    const property = data.properties && typeof data.properties === 'string' ? {_id:data.properties} : data.properties || {}
    this.clients_v2 = client._id
    this.properties = property._id
    this._createdBy = data._createdBy
    this._modifiedBy = data._modifiedBy || data._createdBy
    this.created = data.created || Date.now()
    this.modified = data.modified || this.created
    this.dirName = data.dirName || ReportV2.getNewDirName(data.name, this.created)
    this.report_blocks = mapChildArrayToObjects(data.report_blocks, ReportBlock)
    this.report_top_blocks = data.report_top_blocks || new TopBlock({
      name: this.name,
      date: this.created,

      preparedFor: client.name || null,
      preparedForAddress:null,
      // preparedByAddress: ,
      preparedForPhoto: client.logo || null,
      _reports_v2: this._id,
      _createdBy: this._createdBy
    })
    this.report_preamble_blocks = mapChildArrayToObjects(data.report_preamble_blocks, PreambleBlock)
    this.language_v2 = data[LANG_V2] || null
    this.users = data.users || null
    this.type = ReportV2.getTypeDir()
    this.dbg_collection_id = data.dbg_collection_id
  }

  static getNewDirName(name, created) { return `${name}-${DateToFormattedString(new Date(created), true)}` }

  static getTypeDir() { return REP_V2 }

  static getIndices() { return '_id,name' }

  static sortAllBlocks(a, b, source) {
    if (a.type === TOP_BLOCK) {
      return -1
    } else if (b.type === TOP_BLOCK) {
      return 1
    } else if (a.type === PRE_BLOCK && b.type === PRE_BLOCK) {
      return a.created < b.created ? -1 : 1
    } else if (a.type === PRE_BLOCK && b.type === REP_BLOCK) {
      return -1
    } else if (a.type === REP_BLOCK && b.type === PRE_BLOCK) {
      return 1
    } else if (a.type === REP_BLOCK && b.type === REP_BLOCK) {
      return this.sortReportBlocks(a, b, source)
    }
  }

  static sortReportBlocks(a, b, source) {
    const a_reportSection = source[REP_SEC].find(rep_sec => `${rep_sec._id}` === `${a[REP_SEC]}`);
    const a_subcategory = source[SUB].find(sub => `${sub._id}` === `${a[SUB]}`);
    const b_reportSection = source[REP_SEC].find(rep_sec => `${rep_sec._id}` === `${b[REP_SEC]}`);
    const b_subcategory = source[SUB].find(sub => `${sub._id}` === `${b[SUB]}`);

    if (a[REP_SEC] === b[REP_SEC]) {
      return a_subcategory.fullNumber === b_subcategory.fullNumber ? (
        a._id > b._id ? -1 : 1
      ) : (
        a_subcategory.fullNumber > b_subcategory.fullNumber ? 1 : -1
      )
    } else {
      return a_reportSection.number > b_reportSection.number ? 1 : -1
    }
  }

  static constructFromMetadataAndControls(metadata, controls) {
    const report_top_blocks = controls.filter(block => block.type === TOP_BLOCK)[0]
    return new ReportV2({
      ...metadata,
      name: report_top_blocks.name,
      [TOP_BLOCK]: report_top_blocks,
      [PRE_BLOCK]: controls.filter(block => block.type === PRE_BLOCK),
      [REP_BLOCK]: controls.filter(block => block.type === REP_BLOCK)
    })
  }

  static constructFromCreateReportContents( controls, clients_v2, properties){
    let {name, reportType, language_v2, users} = controls
    console.log('creating report from controls', name, users, controls)
    let reportId = genId()
    const topBlock= new TopBlock({
      [`_${REP_V2}`]: reportId,
      name,
      reportType,
      preparedFor: clients_v2.name,
      preparedForPhoto: clients_v2.logo || null,
      preparedForAddress: [clients_v2.address.streetAddress, clients_v2.address.city, clients_v2.address.state, clients_v2.address.zipCode].join(',\n'),
      coverPhoto: properties.photo || null,
      propertyAddress:[properties.address.streetAddress, properties.address.city, properties.address.state, properties.address.zipCode].join(', ')
    })
    return new ReportV2({
      _id:reportId,
      name,
      language_v2,
      properties,
      clients_v2,
      [TOP_BLOCK]: topBlock,
      users
    })
  }


  async getThumbnailDataForReportImage(image, dataSource) {
    const imageTypeMap = { [PRE_IMG]: PreambleImage, [REP_IMG]: ReportImage }
    let dirName
    // console.log('making thumbail request entry', image, this.dirName)
    if (image.storageLocation && image.storageLocation === 'dbgallery') {
      // const [width, height] = thumbnailSizeMap[image.thumbnailSize].slice(1).split('h')
      return { dbg_id: image.dbg_id, thumbnailSize: image.thumbnailSize, storageLocation: 'dbgallery', _id: image._id }
    }
    if ([CLI_V2, PROP].includes(image.parentType)) {
      dirName = await dataSource('remDb')[image.parentType].get({ _id: image._parentId })
      dirName = dirName.dirName
    } else { dirName = this.dirName }
    return { _id:image._id, thumbnailSize: image.thumbnailSize, path: image.dropboxPath || imageTypeMap[image.type].getDropboxArchivePath(image._id, dirName, image.parentType), storageLocation: 'dropbox' }
  }

  async getPreambleThumbnailData(dataSource) {
    let coverPhotoRes = this.report_top_blocks.coverPhoto && await this.getThumbnailDataForReportImage(new PreambleImage(this.report_top_blocks.coverPhoto), dataSource)
    let preparedForRes = this.report_top_blocks.preparedForPhoto && await this.getThumbnailDataForReportImage(new PreambleImage(this.report_top_blocks.preparedForPhoto), dataSource)
    let preparedByRes = this.report_top_blocks.preparedByPhoto && await this.getThumbnailDataForReportImage(new PreambleImage(this.report_top_blocks.preparedByPhoto), dataSource)
    let signatureRes = this.report_top_blocks.signature && await this.getThumbnailDataForReportImage(new PreambleImage(this.report_top_blocks.signature), dataSource)
    let preambleRes = []
    for (let block of this.report_preamble_blocks) {
      let res = block.preambleImage && await this.getThumbnailDataForReportImage(new PreambleImage(block.preambleImage), dataSource)
      preambleRes.push(res)
    }
    return [
      coverPhotoRes,
      preparedForRes,
      preparedByRes,
      signatureRes,
      ...preambleRes
    ].filter(itm => (!!itm))
  }

  async getReportImageThumbnailData( dataSource) {
    let reportImages = this.report_blocks.reduce((acc, repBlock) => ([...acc, ...repBlock[REP_IMG]]), [])
    let res = []
    for (let image of reportImages) {
      let entry = await this.getThumbnailDataForReportImage(new ReportImage(image), dataSource)
      res.push(entry)
    }
    return res
  }

  getPreambleImageIds() {
    let { coverPhoto, preparedForPhoto, preparedByPhoto, signature } = this.report_top_blocks
    let preamblePhotos = this.report_preamble_blocks.map(preBlock => preBlock.preambleImage)
    return [
      coverPhoto, preparedForPhoto, preparedByPhoto, signature,
      ...preamblePhotos
    ]
  }

  getReportImageIds() {
    return this.report_blocks.reduce((acc, repBlock) => ([...acc, ...repBlock[REP_IMG].map(itm => itm._id)]), [])
  }

  getBatchCounts(preambleIdsLength){
    let batchCountFirst = preambleIdsLength > 25 ? 25 : preambleIdsLength;    
    let batchCountSecond = 25 - preambleIdsLength;
    if(batchCountSecond == 0){
      batchCountSecond = 25;
    }
    return [batchCountFirst, batchCountSecond, 25]
  }

  async getImageMap(userToken, getThumbnails, progressCallback, dataSource, onBatch) {
    const preambleIds = await this.getPreambleThumbnailData(dataSource)
    const reportIds =  await this.getReportImageThumbnailData(dataSource)

    let imagePaths = [
      ...preambleIds,
      ...reportIds
    ]
    let imageMap = {}
    const initialLength = imagePaths.length
    let thumbnailCount = 0
    progressCallback({ num: 0, den: initialLength })
    let [batchCountFirst, batchCountSecond, batchCountRest] = this.getBatchCounts(preambleIds.length);
    let batchCount = batchCountFirst;
    while (imagePaths.length) {
      let bin = imagePaths.splice(0, batchCount);
      
      if(batchCount == batchCountFirst) {
        batchCount = batchCountSecond;
      } else {
        batchCount = batchCountRest;
      }
      thumbnailCount += bin.length
      let res
      res = await getThumbnails(bin, userToken)
      console.log('getReportImageIds | thumbnails result:', res)
      // console.log('getReportImageIds | thumbnails result:', res)
      const deltaMap = res.reduce((acc, cur, idx) => {
        if (cur.thumbnail) {
          return {
            ...acc,
            [cur._id]: cur.thumbnail
          }
        }
        return acc
      }, {})
      imageMap = {
        ...imageMap,
        ...deltaMap
      }
      // emit batch to caller if provided
      if (onBatch && Object.keys(deltaMap).length) onBatch(deltaMap)
      progressCallback({ num: thumbnailCount, den: initialLength })
    }
    return imageMap


  }



  getContents(source) {
    const contents = [
      { ...this.report_top_blocks, type: TOP_BLOCK, schema: 'topBlockSchema', name: this.name },
      ...this.report_preamble_blocks.map(itm => ({ ...itm, type: PRE_BLOCK, schema: 'preambleBlockSchema' })),
      ...this.report_blocks.map(itm => ({ ...itm, type: REP_BLOCK, schema: 'reportBlockSchema' }))
    ]
    if (source) return contents.sort((a, b) => ReportV2.sortAllBlocks(a, b, source))
    else return contents
  }

  getCreateReportContents() {
    return [
      { name: this.name, [USR]: false, [LANG_V2]: false, [CLI_V2]: false, [PROP]:false, reportType: '', schema: 'createReportSchema' }
    ]
  }

  getSchemas() {
    return [
      preambleBlockSchema,
      topBlockSchema,
      reportBlockSchema,
      createReportSchema,
      exportSchema,
      frontMatterSchema,
      exportTableOfContentsSchema,
      exportPreambleBlockSchema,
      exportTopBlockSchema,
      
    ]
  }





}


export { ReportV2 }